module.exports = __webpack_public_path__ + "img/remPutaway.648e7040.png";